import { forwardRef } from 'react';
import type { TestableComponent } from '@mweb/types';
import UtilityStrokeNotificationSmallIcon from '@mweb/zappos-ui/Icons/UtilityStrokeNotificationSmallIcon';
import type { ButtonProps } from '@mweb/zappos-ui/Button';

import Button from 'components/common/Button';
import useMartyContext from 'hooks/useMartyContext';

interface NotifyMeButtonProps extends TestableComponent {
  onClick: ButtonProps['onClick'];
}

export const NotifyMeButton = forwardRef<HTMLButtonElement, NotifyMeButtonProps>((props, ref: any) => {
  const { testId = 'notifyMeButton', onClick } = props;
  const { testId: getTestId } = useMartyContext();

  return (
    <Button
      ref={ref}
      height="small"
      size="base"
      // height of 40px to match add to bag button
      className="relative h-10 w-full"
      onClick={onClick}
      data-test-id={getTestId(testId)}
      // We need to make the stroke thicker
      leadIcon={<UtilityStrokeNotificationSmallIcon size={16} className="[&>path]:stroke-[1.5]" />}
    >
      Notify Me
    </Button>
  );
});
